module.exports = __webpack_public_path__ + "img/folder-minus.ae1ba390.svg";